const $inject = [];

const lbTripOptionsHotelForm = {
  controller: 'lbTripOptionsCarFormCtrl as vm',
  template: require('./lbTripOptionsCarForm.html'),
  bindings: {
    searches: '=',
    optionsForm: '='
  }
};

lbTripOptionsHotelForm.$inject = $inject;

export default lbTripOptionsHotelForm;




// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsCarForm.js